import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import {
  FormGroup,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'
import Textarea from 'components/Textarea'

export class EditableField extends React.Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    form: PropTypes.string,
    textarea: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    handleSubmit: PropTypes.func.isRequired,
    maxLength: PropTypes.number,
    submitOnEnter: PropTypes.bool,
    saveChanges: PropTypes.bool,
    unsavedValue: PropTypes.string,
    initialValue: PropTypes.string,
    addUnsavedChange: PropTypes.func.isRequired,
    removeUnsavedChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.handleFocus = this.handleFocus.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (this.props.input.value !== prevProps.input.value) {
      if (this.props.input.value !== this.props.initialValue) {
        this.props.addUnsavedChange({
          id: this.props.form,
          value: this.props.input.value
        })
      } else {
        this.props.removeUnsavedChange({
          id: this.props.form
        })
      }
    }
  }

  handleFocus (event) {
    const tempValue = event.target.value
    event.target.value = ''
    event.target.value = tempValue
  }

  handleKeyDown (event) {
    const {
      handleSubmit,
      submitOnEnter
    } = this.props

    if (event.key === 'Enter') {
      if (submitOnEnter) {
        if (!event.shiftKey) {
          handleSubmit()
        }
      } else {
        if (event.ctrlKey) {
          handleSubmit()
        }
      }
    }
  }

  render () {
    const {
      input,
      meta,
      textarea,
      maxLength
    } = this.props

    return (
      <FormGroup
        controlId='field'
        validationState={meta.touched && meta.error ? 'error' : null}>
        {!textarea &&
          <FormControl
            {...input}
            name={null}
            type='text'
            autoFocus
            maxLength={maxLength}
            onFocus={this.handleFocus} />
        }
        {textarea &&
          <Textarea
            {...input}
            name={null}
            autoFocus
            minRows={textarea.minRows || 2}
            maxLength={maxLength}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocus}
            {...textarea} />
        }
        {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
      </FormGroup>
    )
  }
}

export class Form extends React.Component {
  static propTypes = {
    form: PropTypes.string,
    textarea: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    buttons: PropTypes.func,
    maxLength: PropTypes.number,
    submitOnEnter: PropTypes.bool,
    saveChanges: PropTypes.bool,
    unsavedValue: PropTypes.string,
    initialValue: PropTypes.string,
    addUnsavedChange: PropTypes.func.isRequired,
    removeUnsavedChange: PropTypes.func.isRequired
  }

  render () {
    const {
      form,
      textarea,
      handleSubmit,
      onCancel,
      buttons,
      maxLength,
      submitOnEnter,
      saveChanges,
      unsavedValue,
      initialValue,
      addUnsavedChange,
      removeUnsavedChange
    } = this.props

    return (
      <form onSubmit={handleSubmit} style={{ maxWidth: 500 }}>
        <Field
          name='name'
          component={EditableField}
          form={form}
          textarea={textarea}
          handleSubmit={handleSubmit}
          maxLength={maxLength}
          submitOnEnter={submitOnEnter}
          saveChanges={saveChanges}
          unsavedValue={unsavedValue}
          initialValue={initialValue}
          addUnsavedChange={addUnsavedChange}
          removeUnsavedChange={removeUnsavedChange} />
        <ButtonGroup>
          <Button type='submit' bsStyle='primary'><FormattedMessage id='SAVE' /></Button>
          {buttons && buttons()}
          <Button onClick={onCancel}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
      </form>
    )
  }
}

export default reduxForm({
  form: 'editable'
})(Form)
